import { integer, pgEnum, pgTable, uuid } from "drizzle-orm/pg-core";
import { createInsertSchema, createSelectSchema } from "drizzle-zod";
import { z } from "zod";

import { customTimestamp } from "./utils/types";

export const consentTypeEnumSchema = z.enum([
  "BROKER_HANDOFF",
  "HEALTH_PLAN_SELECTION",
]);
export type ConsentTypeEnumType = z.infer<typeof consentTypeEnumSchema>;
export const consentTypeEnum = pgEnum(
  "consent_type_enum",
  consentTypeEnumSchema.enum,
);

export const consentsTable = pgTable("consents", {
  id: uuid("id").primaryKey().defaultRandom(),
  type: consentTypeEnum("type").notNull().unique(),
  validityPeriodDays: integer("validity_period_days"),
  createdAt: customTimestamp("created_at")
    .notNull()
    .$defaultFn(() => new Date().toISOString()),
  updatedAt: customTimestamp("updated_at")
    .notNull()
    .$defaultFn(() => new Date().toISOString())
    .$onUpdateFn(() => new Date().toISOString()),
});

export const consentSchema = createSelectSchema(consentsTable, {
  type: consentTypeEnumSchema,
});
export type ConsentType = z.infer<typeof consentSchema>;

export const insertConsentSchema = createInsertSchema(consentsTable, {
  type: consentTypeEnumSchema,
}).omit({
  createdAt: true,
  updatedAt: true,
});
export type InsertConsentType = z.infer<typeof insertConsentSchema>;
